<template>
  <div id="deliveryConfirm">
    <label class="text_size_big bold">商品情報{{index}}</label>
    <div class="input_list">
      <section id="item">
        <ul>
          <li>
            <label class="text_size_big2 bold">シリーズ名：{{itemData.infoSeriesName}}</label>
          </li>
          <li>
            <label class="text_size_big2 bold">商品名：{{itemData.infoProductName}}</label>
          </li>
          <li v-show="itemData.colorStyle">
            <label class="text_size_big2 bold">スタイル名：{{itemData.colorStyle.colorStyleName}}</label>
          </li>
          <li class="list_item3" v-show="isFillerEnable">
            <div class="text_size_middle bold">
              <label>{{titleNoData.filler}}.{{labelFiller}}</label>
            </div>
            <div class="item_box">
              <label class="bold" v-show="itemData.infoFillerLeft!=undefined">{{labelLeftFiller}}:{{itemData.infoFillerLeft}}mm</label>
              <label class="bold" v-show="itemData.infoFillerRight!=undefined">{{labelRightFiller}}:{{itemData.infoFillerRight}}mm</label>
              <label class="bold" v-show="itemData.infoFillerCenter!=undefined">{{labelCenterFiller}}:{{this.itemData.infoFillerCenter}}mm</label>
            </div>
            <div></div>
          </li>
          <li class="list_item3">
            <div class="text_size_middle bold">
              <label>{{titleNoData.size}}.サイズ</label>
            </div>
            <div class="item_box">
              <label class="bold">W:{{itemData.infoW}}mm</label>
              <label class="bold">H:{{itemData.infoH}}mm</label>
              <label class="bold">D:{{itemData.infoD}}mm</label>
            </div>
            <div>
              <button class="main_btn" @click="onEstimate()">図面/見積り</button>
            </div>
          </li>
          <li>
            <ul id="color_list">
              <li v-if="itemData.doorColor">
                <dd-color
                  :title="titleNoData.doorColor + '.扉カラー'"
                  :color="doorColor"
                />
              </li>
              <li v-if="itemData.boxColor">
                <dd-color
                  :title="titleNoData.boxColor + '.キャビネット/棚/脚カラー'"
                  :color="boxColor"
                />
              </li>
              <li v-if="itemData.centerColor">
                <dd-color
                  :title="titleNoData.centerColor + '.カウンターカラー'"
                  :color="centerColor"
                />
              </li>
            </ul>
          </li>
          <li class="list_line2">
            <span class="text_size_middle bold">
              <label>{{titleNoData.construct}}.組立設置</label>
            </span>
            <span>
              <label v-if="itemData.opExFlag===true" class="bold">あり</label>
              <label v-if="itemData.opExFlag===false" class="bold">なし</label>
            </span>
          </li>
          <li class="list_line2" v-if="itemData.opCarryFlag">
            <span class="text_size_middle bold indent2">
              <label>受け取り搬入サービス</label>
            </span>
            <span>
              <label v-if="itemData.opCarryFlag===true" class="bold">あり</label>
              <label v-if="itemData.opCarryFlag===false" class="bold">なし</label>
            </span>
          </li>
          <li>
            <div class="text_size_middle bold order_title">
              <label>{{titleNoData.price}}.合計金額(税抜)</label>
            </div>
            <dd-price
              :priceData="priceData"
              :isCalcDelivery="true"
              :dcProductCount="itemData.infoProductCount"
            />
          </li>
          <li v-if="itemData.infoCategoryType==4 || itemData.infoCategoryType==10 || itemData.infoCategoryType==11 || itemData.infoCategoryType==12 || itemData.infoCategoryType==13">
            <div class="title_list1">
              <label>この商品は、株式会社みうらが製造し、発送します。</label>
              <ul>
                <li>株式会社みうら</li>
                <li>〒746-0022</li>
                <li>山口県周南市野村3丁目24-1</li>
                <li>TEL.0834-63-8811</li>
              </ul>
              <span class="caution text">※自動メールにて返信しますので{{mailTo}}からのメールを受信許可に設定してください。</span>
            </div>
          </li>
          <li v-else>
            <div class="title_list1">
              <label>この商品は、ファニチャーメーカー株式会社が製造し、発送します。</label>
              <ul>
                <li>ファニチャーメーカー株式会社</li>
                <li>〒151-0053</li>
                <li>東京都渋谷区代々木3-28-6 いちご西参道ビル1F</li>
                <li>TEL.03-6300-9085</li>
                <li>FAX.03-6300-9086</li>
              </ul>
              <span class="caution text">※自動メールにて返信しますので{{mailTo}}からのメールを受信許可に設定してください。</span>
            </div>
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>
<script>
import * as App from '../../../utils/App'
import * as FormUtil from '../../../utils/FormUtil'
import Color from '../top/input/color/DcColorForCart'
import Price from '../payment/PriceList'

export default {
  components: {
    'dd-color': Color,
    'dd-price': Price
  },
  props: {
    index: Number,
    itemData: Object
  },
  data () {
    return {
      titleNoData: {}
    }
  },
  computed: {
    priceData: function () {
      let priceData = {
        itemName: this.itemData.infoProductName,
        itemModelList: this.itemData.itemDataList,
        itemPrice: this.itemData.itemPrice,
        constructPrice: this.itemData.constructPrice,
        subTotalPrice: this.itemData.subTotalPrice,
        delivaryPrice: this.itemData.deliveryPrice,
        taxPrice: this.itemData.taxPrice,
        totalPrice: this.itemData.price,
        executionVarExpensesPrice: this.itemData.executionVarExpenses,
        carryInPrice: this.itemData.carryInPrice,
        optionSubTotalPrice: this.itemData.optionSubTotalPrice,
        productCount: this.itemData.infoProductCount
      }
      return priceData
    },
    doorColor: function () {
      if (!this.itemData.doorColor) return
      let bigName = FormUtil.bigImage(this.itemData.doorColor.img)
      let color = {
        id: this.itemData.doorColor.no,
        name: this.itemData.doorColor.name,
        type: this.itemData.doorColor.type,
        no: this.itemData.doorColor.dispNo,
        img: this.getImage('color/' + this.itemData.doorColor.img),
        imgB: this.getImage('color/' + bigName)
      }
      return color
    },
    boxColor: function () {
      if (!this.itemData.boxColor) return
      let bigName = FormUtil.bigImage(this.itemData.boxColor.img)
      let color = {
        id: this.itemData.boxColor.no,
        name: this.itemData.boxColor.name,
        type: this.itemData.boxColor.type,
        no: this.itemData.boxColor.dispNo,
        img: this.getImage('color/' + this.itemData.boxColor.img),
        imgB: this.getImage('color/' + bigName)
      }
      return color
    },
    centerColor: function () {
      if (!this.itemData.centerColor) return
      let bigName = FormUtil.bigImage(this.itemData.centerColor.img)
      let color = {
        id: this.itemData.centerColor.no,
        name: this.itemData.centerColor.name,
        type: this.itemData.centerColor.type,
        no: this.itemData.centerColor.dispNo,
        img: this.getImage('color/' + this.itemData.centerColor.img),
        imgB: this.getImage('color/' + bigName)
      }
      return color
    },
    corpData: function () {
      if (!this.itemData.corpData) return undefined
      let corpData = {
        corpName: this.itemData.corpData.corpName,
        postcd: this.itemData.corpData.postcd,
        address: ((this.itemData.corpData.state ? this.itemData.corpData.state : '') +
          (this.itemData.corpData.city ? this.itemData.corpData.city : '') +
          (this.itemData.corpData.street ? this.itemData.corpData.street : '')),
        tel: this.itemData.corpData.tel,
        fax: this.itemData.corpData.fax
      }
      return corpData
    },
    isFillerEnable: function () {
      return this.itemData.infoFillerLeft !== undefined ||
        this.itemData.infoFillerRight !== undefined ||
        this.itemData.infoFillerCenter !== undefined
    },
    mailTo: function () {
      if (this.itemData.opExFlag) {
        return '「@domans.co.jp」、「@candeal.co.jp」'
      } else {
        return '「@domans.co.jp」'
      }
    },
    labelFiller: function () {
      if (this.itemData.infoCategoryType === 4) return '壁埋め込み'
      return 'フィラー'
    },
    labelLeftFiller: function () {
      if (this.itemData.infoCategoryType === 4) return '左壁埋め込み'
      return '左フィラー'
    },
    labelRightFiller: function () {
      if (this.itemData.infoCategoryType === 4) return '右壁埋め込み'
      return '右フィラー'
    },
    labelCenterFiller: function () {
      if (this.itemData.infoCategoryType === 4) return '奥壁埋め込み'
      return '上部フィラー'
    }
  },
  methods: {
    setTitleNo: function () {
      let count = 1
      this.$set(this.titleNoData, 'filler', count++)
      this.$set(this.titleNoData, 'size', count++)
      if (this.itemData.doorColor && Object.keys(this.itemData.doorColor).length > 0) {
        this.$set(this.titleNoData, 'doorColor', count++)
      }
      if (this.itemData.boxColor && Object.keys(this.itemData.boxColor).length > 0) {
        this.$set(this.titleNoData, 'boxColor', count++)
      }
      if (this.itemData.centerColor && Object.keys(this.itemData.centerColor).length > 0) {
        this.$set(this.titleNoData, 'centerColor', count++)
      }
      this.$set(this.titleNoData, 'construct', count++)
      this.$set(this.titleNoData, 'price', count++)
    },
    onEstimate: function () {
      let estimateData = {
        fileName: this.itemData.infoProductName,
        titleDoor: this.titleNoData.doorColor + '.扉カラー',
        colorDoor: this.doorColor,
        titleCabine: this.titleNoData.boxColor + '.キャビネット/棚/脚カラー',
        colorCabine: this.boxColor,
        titleCounter: this.titleNoData.centerColor + '.カウンターカラー',
        colorCounter: this.centerColor,
        priceData: this.priceData,
        spaceJoincd: this.itemData.infoSpaceJoincd,
        dcProductCount: this.itemData.infoProductCount,
        isDrawing: this.itemData.infoCategoryType !== 5,
        corpData: this.corpData
      }
      this.$emit('onShowEstimateModal', estimateData)
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  },
  mounted: function () {
  },
  created: function () {
    this.setTitleNo()
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/input-list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/order/ItemConfirm.vue